exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-documents__list h3{text-align:center;font-size:22px;font-weight:500}.customer-documents__header{padding:30px 0 5px}.customer-documents__header h2{font-size:18px;letter-spacing:.36px;font-weight:500}", ""]);

// exports
